import React from "react"
import badge from "badges/benefits-of-collaboration.svg"
import { BadgeImage } from "backpack/badges/styled"

const BenefitsOfCollaboration = props => <BadgeImage src={badge} {...props} />

export default BenefitsOfCollaboration
